export const CONTACT = {
    email: "info@emsglueck.com",
    street: "Borkumer Straße 29a",
    city: "26871 Papenburg",
    mailtoBooking:
        "mailto:info@emsglueck.com?subject=Buchungsanfrage%20%E2%80%93%20Ferienwohnung%20Emsgl%C3%BCck",
    mailtoContact: "mailto:info@emsglueck.com?subject=Kontakt%20%E2%80%93%20Emsgl%C3%BCck",
};

export const NAV_ITEMS = [
    { label: "Über uns", href: "#ueber-uns" },
    { label: "Wohnung", href: "#wohnung" },
    { label: "Galerie", href: "#galerie" },
    { label: "Lage", href: "#lage" },
    { label: "Papenburg", href: "#papenburg" },
    { label: "Preise", href: "#preise" },
    { label: "FAQ", href: "#faq" },
    { label: "Anfrage", href: "#anfrage" },
];

export const AMENITIES = [
    { icon: "Ruler", label: "88 m² Wohnfläche" },
    { icon: "BedDouble", label: "2 Schlafzimmer" },
    { icon: "Laptop", label: "Schreibtisch im Schlafzimmer" },
    { icon: "Sun", label: "Heller Wohnbereich" },
    { icon: "PanelTop", label: "Große Fensterfront" },
    { icon: "ChefHat", label: "Voll ausgestattete Küche" },
    { icon: "Bath", label: "Modernes Badezimmer" },
    { icon: "Droplets", label: "Badewanne & Dusche" },
    { icon: "WashingMachine", label: "Waschmaschine" },
    { icon: "Wifi", label: "Kostenloses WLAN" },
    { icon: "Trees", label: "Ruhige Lage" },
    { icon: "Car", label: "Kostenlose Parkplätze" },
    { icon: "Users", label: "Ideal für Familien" },
    { icon: "Briefcase", label: "Ideal für Projektleiter" },
    { icon: "CalendarClock", label: "Kurz- & Langzeitaufenthalte" },
];

export const IMAGES = {
    // pew9a0tk_DSC05357 = Flur mit Pop-Art-Wandbildern
    flurKunst:
        "https://customer-assets.emergentagent.com/job_document-hunt/artifacts/pew9a0tk_DSC05357.webp",
    // 1h5efg8u_DSC05342 = Schlafzimmer 1 mit floralen Kissen
    schlafzimmerFloral:
        "https://customer-assets.emergentagent.com/job_document-hunt/artifacts/1h5efg8u_DSC05342.webp",
    // 3y0r5oah_Design(9) = Esstisch-Panorama im Wintergarten (HIGHLIGHT für Hero)
    heroWintergarten:
        "https://customer-assets.emergentagent.com/job_document-hunt/artifacts/3y0r5oah_Design%20ohne%20Titel%20%289%29.webp",
    // 5r25uyj4_Design(10) = Schlafzimmer 2 mit Boho-Wanddeko
    schlafzimmer:
        "https://customer-assets.emergentagent.com/job_document-hunt/artifacts/5r25uyj4_Design%20ohne%20Titel%20%2810%29.webp",
    // cgwwflss_Design(8) = Küche/Flur mit "La Dolce Vita"
    kuecheFlur:
        "https://customer-assets.emergentagent.com/job_document-hunt/artifacts/cgwwflss_Design%20ohne%20Titel%20%288%29.webp",
    // Neue Fotos
    kuecheWeiss:
        "https://customer-assets.emergentagent.com/job_document-hunt/artifacts/3v6udgwo_DSC05276.webp",
    schlafzimmerHell:
        "https://customer-assets.emergentagent.com/job_document-hunt/artifacts/6hh9qek0_DSC05221.webp",
    badezimmer:
        "https://customer-assets.emergentagent.com/job_document-hunt/artifacts/6p9jedok_DSC05200.webp",
};

export const GALLERY = [
    { src: IMAGES.heroWintergarten, alt: "Esstisch-Panorama im lichtdurchfluteten Wintergarten der Ferienwohnung Papenburg" },
    { src: IMAGES.kuecheWeiss, alt: "Voll ausgestattete weiße Küche mit Backofen, Geschirrspüler und Kaffeemaschine" },
    { src: IMAGES.schlafzimmerFloral, alt: "Helles Schlafzimmer mit Doppelbett und Fensterblick ins Grüne" },
    { src: IMAGES.badezimmer, alt: "Modernes Badezimmer mit Badewanne, Regendusche und Waschmaschine" },
    { src: IMAGES.schlafzimmerHell, alt: "Zweites Schlafzimmer mit Doppelbett und floralen Textilien" },
    { src: IMAGES.schlafzimmer, alt: "Schlafzimmer mit Boho-Wanddeko und Naturholz" },
    { src: IMAGES.kuecheFlur, alt: "Blick in die voll ausgestattete Küche des Emsglück" },
    { src: IMAGES.flurKunst, alt: "Flur mit Pop-Art-Wandbildern im Emsglück Papenburg" },
];

export const VALUE_PROPS = [
    {
        icon: "Home",
        title: "Zuhause statt Hotel",
        text: "Mehr Platz, mehr Komfort und mehr Privatsphäre – ein echtes Zuhause auf Zeit.",
    },
    {
        icon: "Users",
        title: "Für Familien",
        text: "Viel Raum zum Wohlfühlen. Kinderfreundlich und mit allem, was der Alltag braucht.",
    },
    {
        icon: "Briefcase",
        title: "Für Projektleiter",
        text: "Ruhiger Rückzugsort mit Schreibtisch, schnellem WLAN und voll ausgestatteter Küche – ideal für längere Projekteinsätze.",
    },
    {
        icon: "MapPin",
        title: "Perfekte Lage",
        text: "Zentral in Papenburg mit kurzen Wegen – Innenstadt und Meyer Werft in wenigen Minuten.",
    },
];

export const NEARBY = [
    { name: "Meyer Werft", meta: "ca. 4,9 km · 5 Min. mit dem Auto" },
    { name: "Innenstadt Papenburg", meta: "ca. 1,5 km · 3 Min. mit dem Auto" },
    { name: "Restaurants", meta: "fußläufig erreichbar" },
    { name: "Supermärkte", meta: "wenige Minuten entfernt" },
    { name: "Bäcker", meta: "in der Nachbarschaft" },
    { name: "Rad- und Spazierwege", meta: "direkt ab der Wohnung" },
    { name: "Freizeitmöglichkeiten", meta: "Emsland vor der Tür" },
    { name: "Gute Verkehrsanbindung", meta: "A31 in wenigen Minuten" },
];

export const BUSINESS_ROLES = [
    "Projektleiter",
    "Bauleiter & Bauingenieure",
    "Ingenieure",
    "Servicetechniker",
    "Außendienstmitarbeiter",
    "Geschäftsreisende",
    "Monteure",
];

export const DISTANCES = [
    { label: "Meyer Werft", value: "4,9 km", note: "ca. 5 Min." },
    { label: "Innenstadt Papenburg", value: "1,5 km", note: "ca. 3 Min." },
    { label: "Autobahn A31", value: "wenige Min.", note: "direkte Anbindung" },
];

export const PAPENBURG_DISCOVER = {
    intro: "Papenburg – die längste Fehnkolonie Deutschlands – verbindet Werft-Tradition mit Emsland-Idylle. Zwischen historischen Kanälen, dem Emsauenpark und weiten Rad- und Wanderwegen findest Du hier alles, was einen entspannten Aufenthalt ausmacht.",
    highlights: [
        { title: "Meyer Werft", text: "Weltberühmte Kreuzfahrtschiff-Werft mit Besucherzentrum – nur 4,9 km entfernt." },
        { title: "Historische Innenstadt", text: "Fußgängerzone, Cafés, Restaurants und der lange Hauptkanal – 3 Min. mit dem Auto." },
        { title: "Emsauenpark & Von-Velen-Anlage", text: "Grüne Naherholung direkt in Papenburg – ideal für Spaziergänge und Radtouren." },
        { title: "Emsland & Ostfriesland", text: "Leer, Aschendorf, Rhede, Weener, die Nordseeküste und Meppen – alles bequem als Tagesausflug erreichbar." },
    ],
};

export const FAQS = [
    {
        q: "Wann ist Check-In?",
        a: "Der Check-In ist ab 15:00 Uhr möglich. Individuelle Ankunftszeiten stimmen wir gerne per E-Mail ab.",
    },
    {
        q: "Wann ist Check-Out?",
        a: "Der Check-Out erfolgt bis 11:00 Uhr am Abreisetag. Bei Bedarf ist ein späterer Check-Out nach Absprache möglich.",
    },
    {
        q: "Sind Haustiere erlaubt?",
        a: "Haustiere sind grundsätzlich nicht erlaubt, damit sich alle Gäste – auch Allergiker – rundum wohlfühlen. Bitte sprechen Sie uns bei Fragen an.",
    },
    {
        q: "Gibt es WLAN?",
        a: "Ja, in der gesamten Wohnung steht Ihnen kostenloses, schnelles WLAN zur Verfügung – ideal fürs Homeoffice oder Streaming.",
    },
    {
        q: "Gibt es Parkplätze?",
        a: "Ja, kostenlose Parkmöglichkeiten stehen direkt an der Wohnung zur Verfügung.",
    },
    {
        q: "Ist die Küche komplett ausgestattet?",
        a: "Ja, die Küche ist mit Herd, Backofen, Kühlschrank, Geschirrspüler, Kaffeemaschine sowie Geschirr, Töpfen und Besteck vollständig ausgestattet.",
    },
    {
        q: "Ist die Wohnung für Projektleiter und Geschäftsreisende geeignet?",
        a: "Ja, ganz besonders. Die Wohnung ist auf längere berufliche Aufenthalte ausgelegt: eigener Arbeitsplatz mit Schreibtisch, schnelles WLAN, voll ausgestattete Küche und ein ruhiger Rückzugsort nach Feierabend – für Projektleiter, Bauleiter, Servicetechniker und Monteure gleichermaßen.",
    },
    {
        q: "Wie funktioniert die Buchung?",
        a: "Ganz einfach: Sie senden uns eine kurze E-Mail mit Ihrem Wunschzeitraum. Wir prüfen die Verfügbarkeit und melden uns schnellstmöglich mit einem persönlichen Angebot zurück.",
    },
];
